export default "__VITE_ASSET__$Px3Fn2t__"